import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  totalLength = 0;
  hmoNotAssign =[]
  statsForm;
  usersStats = [];
  users =[];
  HMO = ['Macabi', 'Leumit', 'Meuhedet', 'Clalit', 'IDF', 'Private' ]
  code;
  Params;
  isCardio;
  examsArray = [];
  statsLoaded$ = new Subject();
  CARDIO = [
    "TTE Adults",
    "TTE Pediatric",
    "Stress",
    "Stress-Echo",
    "Holter ECG",
    "Duplex Carotid",
    "Pulmonary functional assessment",
    "Methacholine test",
    "Consultation Letter",
    "All",
  ];

  constructor(private http:HttpClient, private fb: UntypedFormBuilder, private ls:LoginService) { 
    this.resetForm();
    
  }
  resetForm(){
    this.statsForm = this.fb.group({
      Colonoscopy:[''],
      Gastroscopy:[''],
      Sigmoidoscopy:[''],
      Gynecology :[''],
      CVS :[''],
      Amniocentesis :[''],
      Follicles:[''],
      first:[''],
      NT:[''],
      Early:[''],
      second:[''],
      WeightAssessment:[''],
      TechExam:[''],
      Late:[''],
      Specialized:[''],
      FetalEcho:[''],
      All:[''],
      start:[''],
      end:[''],
      exams:[''],
      Admission:[''],
      TimeOut:[''],
      AllForms:[''],
      examsUsers:[''],
      formsUsers:[''],
      TTEAdults:[''],
      TTEPediatric:[''],
      Stress:[''],
      DuplexCarotid:[''],
      StressEcho:[''],
      EmergencyRoom:[''],
      HolterECG:[''],
      Pulmonaryfunctionalassessment:[''],
      Methacholinetest:[''],
      ConsultationLetter:[''],
    })
  }

  search(params, code=null){
    if(code){
      this.code = code;
      this.loadData(code)
    }
    this.Params = params;

    this.http.get('/api/stats', {'params':params}).subscribe((data) => {
      this.resetForm();
      if(params.end && params.start){
        this.statsForm.get('start').setValue(params.start)
        this.statsForm.get('end').setValue(params.end)
      }else{
        this.statsForm.patchValue(data)
      }
      if(data['type'] =='CARDIO'){
        this.ls.isCardio = true;
        this.ls.isGastro = false;
        this.examsArray = this.CARDIO;
      }
      this.filterData(data);
      this.statsLoaded$.next(undefined)
    })
    
  }
  filterByHMO(data,hmo){
    if(!data)
      return []
    var temp = data;
    this.hmoNotAssign = temp.filter((i) => i.HMO ==null)
    return temp.filter((i) => i.HMO ==hmo)
    // if(temp.length > 0 ){
    // }
    // return temp
    
  }

  filterData(data){
    this.usersStats = data['data'];
    var str;

      if(data['All']){
        var exams = data['All'];
        this.totalLength = exams.length;
        this.statsForm.get('All').setValue(exams);
        for(let i=0; i<this.CARDIO.filter((i)=> i !='All').length; i++){
          str = this.CARDIO[i].replace(/ /g, '').replace('-', '');
          this.statsForm.get(str).setValue(exams.filter((exam) => exam.ExamType == this.CARDIO[i]))
        }
  }
    
  }
  loadData(code){
    this.code = code;
    this.http.post('/api/print/resurection', {code:code}).subscribe((data) => {
      this.search(this.Params);
    })
  }

}
